// extracted by mini-css-extract-plugin
export default {"main":"saHKeUqhRnioIWc8qDyw","common_bganimation":"qvgASyEhMRBBiI_dz7BU"};